import { render, staticRenderFns } from "./CadProblema.vue?vue&type=template&id=3912000c&"
import script from "./CadProblema.vue?vue&type=script&lang=js&"
export * from "./CadProblema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports